import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';

export const ArtifactRail = ({ realm, slug }) => {
  const pieces = realm.pieces;
  const i = pieces.findIndex((p) => p.slug === slug);
  const prev = i > 0 ? { to: `/product/${pieces[i - 1].slug}`, name: pieces[i - 1].name } : realm.rail.before;
  const next = i < pieces.length - 1 ? { to: `/product/${pieces[i + 1].slug}`, name: pieces[i + 1].name } : realm.rail.after;

  return (
    <nav className="arail" aria-label="Previous and next" data-testid="artifact-rail">
      <Link to={prev.to} className="arail-link" data-testid="rail-prev">
        <span className="arail-eyebrow"><ArrowLeft className="w-3 h-3" strokeWidth={1.25} /> Prev</span>
        <span className="arail-name">{prev.name}</span>
      </Link>
      <span className="arail-star" aria-hidden><i /><b>✦</b><i /></span>
      <Link to={next.to} className="arail-link arail-link--next" data-testid="rail-next">
        <span className="arail-eyebrow">Next <ArrowRight className="w-3 h-3" strokeWidth={1.25} /></span>
        <span className="arail-name">{next.name}</span>
      </Link>
    </nav>
  );
};
